import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@gemini/core';
export const FOOTNOTES = {
    1: { marker: '¹', ref: 'ref1' },
    2: { marker: '²', ref: 'ref2' },
};
export const AddFootnoteRef = (text) => {
    const pattern = Object.values(FOOTNOTES)
        .map((x) => x.marker)
        .join('|');
    const parts = text.split(new RegExp(`(${pattern})`, 'gi'));
    const wrappedText = parts.map((part) => {
        const footnote = Object.values(FOOTNOTES).find((x) => x.marker === part);
        return footnote ? (_jsx(Box, { as: "a", href: `#${footnote.ref}`, rel: "footnote", unsafe_style: { textDecoration: 'none' }, color: "color.content.active.default", children: part }, footnote.marker)) : (part);
    });
    return _jsx("span", { children: wrappedText });
};
